import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import useNewCapability from 'sharedHooks/useNewCapability';
import { getTrendCommentsRequest, setTrendCommentsDrawerVisible, setTrendCommentsModalVisible } from '../TrendComments/actions';
import * as commonActions from '../actions';
import * as energyActions from '../EnergyRelatedSignalsList/actions';
import TrendChartComponent from './TrendChartComponent';

import { getModel } from './selectors';


const TrendChartContainer = (props) => {
    const { model, /*actions*/ } = props;

    const capability = useNewCapability();

    useEffect(() => {
        // if (capability.isSet()) {
        //     if (capability.isSmartSensor() && model.trendHealthStatuses.length || !capability.isSmartSensor()) {
        //         actions.getUserLimits(props.asset, true);
        //     }
        // } // UN-COMMENT THIS CODE WHEN NEED TO CALL USERLIMITS API
    }, [capability, model.trendHealthStatuses]);

    return <TrendChartComponent {...props} />;
};
TrendChartContainer.propTypes = {
    model: PropTypes.shape({
        trendHealthStatuses: PropTypes.array, // <-- Add this line
    }),
    asset: PropTypes.object,
    actions: PropTypes.object,
};
const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...commonActions, setTrendCommentsDrawerVisible, setTrendCommentsModalVisible, getTrendCommentsRequest, ...energyActions }, dispatch)
    };
};

const TrendKPIListContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(TrendChartContainer);

export default TrendKPIListContainerConn;
